import { render, staticRenderFns } from "./TheRoadmapItemEdit.vue?vue&type=template&id=8a2d8dbc&scoped=true&"
import script from "./TheRoadmapItemEdit.vue?vue&type=script&lang=ts&"
export * from "./TheRoadmapItemEdit.vue?vue&type=script&lang=ts&"
import style0 from "./TheRoadmapItemEdit.vue?vue&type=style&index=0&id=8a2d8dbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2d8dbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/winfakt-authentication-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a2d8dbc')) {
      api.createRecord('8a2d8dbc', component.options)
    } else {
      api.reload('8a2d8dbc', component.options)
    }
    module.hot.accept("./TheRoadmapItemEdit.vue?vue&type=template&id=8a2d8dbc&scoped=true&", function () {
      api.rerender('8a2d8dbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/TheRoadmapItemEdit.vue"
export default component.exports